module.exports = __webpack_public_path__ + "img/collection-engagementRingsDiamonds.6fdb05c.webp";